<template>
  <div style="height: 100%">
    <home-app-bar />
    <home-view />
    <home-footer />
  </div>
</template>

<script>
  export default {
    name: 'HomeLayout',

    components: {
      HomeAppBar: () => import('@/layouts/home/AppBar'),
      HomeFooter: () => import('@/layouts/home/Footer'),
      HomeView: () => import('@/layouts/home/View'),
    },
  }
</script>
